import React from 'react'
import {useTranslation} from 'react-i18next'
import {Button, ButtonType} from '../../../UIkit/components/controls/Button/Button.tsx'
import {Eye} from '../../../UIkit/components/icons/Eye.tsx'
import {EyeClosed} from '../../../UIkit/components/icons/EyeClosed.tsx'
import {Lock} from '../../../UIkit/components/icons/Lock.tsx'
import useShowHide from '../../utils/useShowHide.ts'
import {Input, InputHandlers, Props as InputProps} from './InputNative.tsx'
import {Stack} from "../Stack/Stack.tsx";
import {Gt} from "../../i18n/Gt.tsx";
import {Body_12_Coral_Empasis_12} from "../../../UIkit/typography/generated/typography.tsx";
import styles from "../../Pages/LoginPage/LoginPage.module.less";
import cn from "classnames";
import {Colors} from "../../../UIkit/theme/generated/Colors.ts";


export interface WithErrorProps extends InputProps {
    hasError?: boolean
}

export const PasswordInput = React.forwardRef<InputHandlers, WithErrorProps>(
    ({name = 'password', placeholder, hasError, className, ...props}, ref) => {
        const {visible, toggle} = useShowHide(false)
        const {t} = useTranslation()
        return (
            <Stack direction={"column"} gap={4}>
                <Body_12_Coral_Empasis_12>
                    <Gt>Password</Gt>
                </Body_12_Coral_Empasis_12>
                <Input
                    ref={ref}
                    leftIcon={<Lock color={hasError ? Colors.Coral_special_Error_red : undefined} />}
                    required
                    initialValue={import.meta.env.VITE_DEBUG_PASSWORD}
                    name={name || 'password'}
                    type={visible ? 'text' : 'password'}
                    autoComplete='current-password'
                    placeholder={placeholder || t('Input password')}
                    className={cn(className, {[styles.errorInput]: hasError })}
                    rightIcon={
                        <Button onClick={() => toggle()}
                                icon={visible ? <Eye color={Colors.Obsidian_Dark_0}/> : <EyeClosed color={Colors.Obsidian_Dark_0}/>}
                                type={ButtonType.clickableIcon}/>
                    }
                    {...props}
                />
            </Stack>

        )
    }
)
